import type { ApiMetric } from '@/stores/diagnosticsStore'
import { format } from 'date-fns'

const triggerDownload = (filename: string, content: string, mimeType: string): void => {
	const blob = new Blob([content], { type: mimeType })
	const url = URL.createObjectURL(blob)
	const link = document.createElement('a')
	link.href = url
	link.download = filename
	document.body.appendChild(link)
	link.click()
	document.body.removeChild(link)
	URL.revokeObjectURL(url)
}

const timestampForFilename = (): string => {
	const d = new Date()
	const pad = (n: number): string => String(n).padStart(2, '0')
	return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}-${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`
}

export const exportDiagnosticsAsCsv = (metrics: ApiMetric[]): void => {
	const headers = [
		'Method',
		'URL',
		'Status',
		'Duration (ms)',
		'Server (ms)',
		'Transfer (ms)',
		'Overhead (ms)',
		'Client',
		'Time',
		'Success',
		'Error',
	]
	const escapeCell = (value: unknown): string => {
		if (value === undefined || value === null) {
			return ''
		}
		const str = String(value)
		if (str.includes(',') || str.includes('"') || str.includes('\n')) {
			return `"${str.replace(/"/g, '""')}"`
		}
		return str
	}
	const formatMs = (value: number | undefined): string => {
		if (value === undefined || Number.isNaN(value)) {
			return ''
		}
		return Math.round(value).toString()
	}
	const rows = metrics.map(m => {
		const overhead = Math.max(0, m.duration - (m.ttfb ?? 0) - (m.download ?? 0))
		return [
			m.method,
			m.url,
			m.status ?? '',
			Math.round(m.duration),
			formatMs(m.ttfb),
			formatMs(m.download),
			formatMs(overhead),
			m.clientName,
			format(new Date(m.timestamp), 'yyyy-MM-dd HH:mm:ss.SSS'),
			m.success,
			m.errorMessage ?? '',
		]
			.map(escapeCell)
			.join(',')
	})
	const csv = [headers.join(','), ...rows].join('\n')
	triggerDownload(`diagnostics-${timestampForFilename()}.csv`, csv, 'text/csv')
}
